import { IDanhSachKhongDuDieuKienThucTapResponse } from "../../../model/response/xet-thuc-tap/IDanhSachKhongDuDieuKienThucTapResponse";
import { IDanhSachKhongDuDieuKienThucTapViewModel } from "../../../model/response/xet-thuc-tap/IDanhSachKhongDuDieuKienThucTapViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachKhongDuDieuKienThucTapActionsObj = {
    LOAD_BY_DOT_THUC_TAP_START: 0,
    LOAD_BY_DOT_THUC_TAP_SUCCESS: {} as IDanhSachKhongDuDieuKienThucTapViewModel[], // Replace 'any' with the actual type if available
    LOAD_BY_DOT_THUC_TAP_ERROR: "",

    LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START: 0,
    LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_SUCCESS: {} as IDanhSachKhongDuDieuKienThucTapResponse, // Replace 'any' with the actual type if available
    LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR: "",

    CHUYEN_DU_DIEU_KIEN_START: {} as { id: number, id_dot_thuc_tap: number },
    CHUYEN_DU_DIEU_KIEN_SUCCESS: undefined,
    CHUYEN_DU_DIEU_KIEN_ERROR: "",
}

export const eDanhSachKhongDuDieuKienThucTapActionIds = generateActionTypeIds(eDanhSachKhongDuDieuKienThucTapActionsObj, "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP");
export type IDanhSachKhongDuDieuKienThucTapActionTypes = IGenericActionType<typeof eDanhSachKhongDuDieuKienThucTapActionsObj, "DANH_SACH_KHONG_DU_DIEU_KIEN_THUC_TAP">;